import { useContext } from 'react';
import { AngularContext } from 'react-app';
import SubmissionsGalleryContent from './submissions-gallery-content';

const SubmissionsGallery = () => {
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);
  const rolePlayId = Number($state?.params?.rolePlayId);

  return <SubmissionsGalleryContent rolePlayId={rolePlayId} />;
};

export default SubmissionsGallery;
